import InlineStyleControls from './InlineStyleControls'
export default InlineStyleControls



/** WEBPACK FOOTER **
 ** ./src/Editors/InlineStyleControls/index.js
 **/